<template>
    <div>
        <div class="flex justify-between mb-5 border-b border-gray-200 pb-2">
            <div class="flex items-center justify-between w-full">
                <h1 class="module-header">Employee Counts</h1>
                <div>
                    <button 
                        @click="editing = true"
                        v-if="! editing"
                        class="flex items-center btn btn-small btn-indigo">
                            <inline-svg name="edit" classes="w-4 h-4 text-white fill-current"></inline-svg>
                            <span class="ml-2">Edit Employee Counts</span>
                    </button>
                    <button 
                        @click="saveEmployeeCounts"
                        v-if="editing"
                        class="flex items-center btn btn-small btn-green">
                            <inline-svg name="save" classes="w-4 h-4 text-white fill-current"></inline-svg>
                            <span class="ml-2">Save Employee Counts</span>
                    </button>
                </div>
            </div>
        </div>
        <div id="employeeCountsContainer" class="flex overflow-auto">
            <div v-for="(counts, countsIndex) in employeeCounts" :key="countsIndex" class="flex-grow">
                <div class="flex flex-col border border-r-0 border-gray-300">
                    <div class="bg-gray-700 text-white text-base text-center font-semibold py-3" v-text="counts.year"></div>
                    <div class="p-1 flex justify-around gap-x-3 bg-white">
                        <div class="flex flex-col items-center">
                            <input v-if="editing" @keyup="updateChart" class="form-input w-16 mr-1 text-center mb-2" type="text" placeholder="FTE" v-model.number="counts.fte">
                            <p v-if="! editing" class="my-1 text-blue-darker">{{ counts.fte }}</p>
                            <span class="text-xs">FTE</span>
                        </div>
                        <div class="flex flex-col items-center">
                            <input v-if="editing" @keyup="updateChart" class="form-input w-16 text-center mb-2" type="text" placeholder="CTE" v-model.number="counts.cte">
                            <p v-if="! editing" class="my-1 text-blue-darker">{{ counts.cte }}</p>
                            <span class="text-xs">CTE</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showChart" class="mt-4">
            <fusioncharts
                type="area2d"
                width="100%"
                height="400"
                ref="employeeCountChart"
                :dataSource="dataSource"
                v-observe-visibility="{ callback: updateChart, once: true, intersection: { threshold: 0.9 }}">
            </fusioncharts>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    
    export default {
        props: {
            siteId: {
                type: Number,
                required: true
            },     

            data: {
                type: [Array, Object],
                required: false
            },

            showChart: {
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
                editing: false,
            }
        },

        mounted() {

            // if (currentYear < moment().year()) {
            //     while (moment().add(1, 'year').year() > currentYear) {
            //         this.data[currentYear] = {
            //             cte: 0,
            //             fte: 0,
            //         }

            //         currentYear++;
            //     }
            // }
        },

        methods: {
            updateChart(visible) {
                if (visible) {
                    const chart = this.$refs.employeeCountChart?.chartObj

                    if (chart) {
                        this.dataSource.data = _.map(this.employeeCounts, (row, year) => {
                            return {
                                'label': year,
                                'value': (row.fte ? row.fte : 0) + (row.cte ? row.cte : 0)
                            }
                        })

                        chart.setChartData(this.dataSource);
                    }
                }
            },

            saveEmployeeCounts() {
                axios.post('/sites/' + this.siteId + '/employee-counts', { counts: this.employeeCounts })
                    .then((response) => {
                        this.$eventHub.$emit('site-saved', response.data.site);
                        
                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: response.data.message
                        });
                    })
                    .catch((response) => {
                        console.error(response);
                    }).finally(() => {
                        this.editing = false;
                    });
            }
        },

        computed: {
            employeeCounts() {
                if (this.data) {
                    return _.orderBy(this.data, 'year', 'desc');
                }

                return this.years;
            },

            years() {
                let years = _.keyBy(_.map(_.range(2010, moment().add(1, 'year').year()), (value, key) => {
                    return {
                        'year': value,
                        'fte': 0,
                        'cte': 0
                    }
                }), 'year');

                return _.orderBy(years, 'year', 'desc');
            },

            dataSource() {
                return {
                    chart: {
                        theme: "fusion",
                        caption: "Employee Count by Year",
                    },
                    data: {},
                }
            },
        },
    }
</script>